import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Production HTML is pre-rendered for readers and crawlers before React starts.
ReactDOM.createRoot(document.getElementById('root')).render(<React.StrictMode><App /></React.StrictMode>);